import React from 'react';
import { Button, Modal, Typography, message, List } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { cleanImportLayout, updateValidatedImport } from '../header/header-actions';
import { getImportLoading } from '../header/header-reducer';
import { OfficeTabs } from './OfficeTabs';

const { Text } = Typography;

export const ImportFileValidationModal = ({ visible, data }) => {
  const dispatch = useDispatch();
  const isImportLoading = useSelector(getImportLoading);

  return (
    <StyledValidationModal
      visible={visible}
      onCancel={() => dispatch(cleanImportLayout())}
      footer={
        <>
          <Button type={'ghost'} onClick={() => dispatch(cleanImportLayout())}>
            Ok
          </Button>
        </>
      }
    >
      <StyledTitle>
        <Text strong style={{ color: 'red', fontSize: '24px' }}>
          Import Failed
        </Text>
      </StyledTitle>
      <List
        header={
          <div style={{ fontWeight: 'bold' }}>
            <span style={{ color: 'red' }}>Issues Found in Import File</span>
          </div>
        }
        bordered
        dataSource={data}
        renderItem={(item) => <List.Item>{item}</List.Item>}
      />
    </StyledValidationModal>
  );
};

const StyledValidationModal = styled(Modal)`
  .ant-modal-content {
    width: initial;
    max-width: 800px;
  }
`;

const StyledTitle = styled.div`
  margin: 15px 0 25px;
  width: 100%;
  text-align: center;
`;
